import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const coupa = defineConnector({
  identifier: "coupa",
  name: "Coupa",
  tagLine: "Business spend management",
  logo,
  protocol: "http",
  tags: ["productivity", "data"],
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Coupa OAuth client",
      items: [
        {
          kind: "markdown",
          content:
            "Create an OAuth 2.0 client in your Coupa instance with the scopes your integration needs. Coupa’s current API docs use OAuth rather than legacy API keys.",
        },
      ],
    },
    {
      title: "Enter your Coupa details",
      items: [
        {
          kind: "baseUrl",
          label: "Coupa base URL",
          required: true,
          placeholder: "https://company.coupahost.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
        {
          kind: "input",
          label: "Scopes",
          required: true,
          defaultValue: "core.common.read",
          helperText: "Space separated list of Coupa scopes.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ instanceUrl }) => `${instanceUrl}/oauth2/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => ({
      url: `${instanceUrl}/api/users?limit=1`,
      expectedStatus: [200, 403],
    }),
  },
});
